import CheckCircle from "components/inputs/checkBox/CheckCircle";
import InputText from "components/inputs/InputText";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import style from "./ShippingInfomation.module.css";
import NiceModal from "@ebay/nice-modal-react";
import { CFormSelect } from "@coreui/react";
import { useTransition } from "react";
import { useTranslation } from "react-i18next";
import { textFormat, mobileNoFormat } from "InitialData/regExp";
import { validateInputs } from "shared/utils/Utils";
import Select from "react-select";
import { storeRequester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Flex from "layouts/flex/Flex";
import CustomButton from "components/buttons/CustomButton";
import RadioGroup from "components/manager/views/forms/radio/RadioGroup";

import Radio from "components/inputs/radio/Radio";
import { toast } from "react-toastify";
import { Button } from "@mui/material";

function ShippingInfomation(props) {
  const { width, isMobile } = useContext(BrowserDetectContext);

  const inputs = useRef([]);
  const provinceSelectRef = useRef();
  const citySelectRef = useRef();
  const postalCodeSelectRef = useRef();
  const [defaultShippingInfo, setDefaultShippingInfo] = useState();
  const [shippingInfos, setShippingInfos] = useState([]);
  const [provinces, setProvinces] = useState();
  const [cities, setCities] = useState();
  const [postalCodes, setPostalCodes] = useState();
  const [selectedProvince, setSelectedProvince] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [selectedPostalCode, setSelectedPostalCode] = useState();
  const [selectedShippingInfo, setSelectedShippingInfo] = useState();
  const [shippingInfo, setShippingInfo] = useState([]);
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [data, setData] = useState();
  const [mounted, setMounted] = useState(false);
  const [type, setType] = useState("EXISTING");
  const { t } = useTranslation();
  const { shippingAddress } = props;
  const { setAdd } = props;
  const { setSelectAddressId } = props;
  const { setSelectAddress } = props;
  const { selectAddressId } = props;

  useEffect(() => {
    setSelectAddress(selectedShippingInfo);
  }, [selectedShippingInfo]);

  const shippingInfoClick = () => {
    NiceModal.show("shippingInfoSelectModal", {
      // props 전달
      callback: shippingInfoCallback,
      shippingAddress: shippingAddress,
      setSelectedShippingInfo: setSelectedShippingInfo,
      selectAddressId: selectAddressId,
      setSelectAddressId: setSelectAddressId,
      setSelectAddress: setSelectAddress,
    });
  };
  const shippingInfoCallback = (value, disabled, check) => {
    setDisabled(disabled);
    setShippingInfo(value);
    setDefaultShippingInfo(value);
    if (check) {
      setChecked(check);
    } else {
      setChecked(false);
    }
    setChecked(check);
  };

  const handleCheckedChange = (type) => {
    setEnroll_company();

    if (type === "NEW") {
      setType("NEW");
      setDisabled(false);
    } else {
      setType("EXISTING");
      setDisabled(true);
    }
  };

  useEffect(() => {
    if (selectedProvince) {
      if (type === "EXISTING") {
        let data = { cityId: shippingInfo.cityId };
        // requester.getCity(data, (result) => {
        //   setSelectedCity(result.data);
        // });
      } else {
        let data = { provinceId: selectedProvince.id };
        // requester.getAllCitiesByProvinceId(data, (result) => {
        //   setCities(result.data);
        //   setPostalCodes();
        //   setSelectedCity();
        //   setSelectedPostalCode();
        // });
      }
    }
  }, [selectedProvince]);

  useEffect(() => {
    if (selectedCity) {
      if (type === "EXISTING") {
        let data = { postalCodeId: shippingInfo.postalCodeId };
        // requester.getpostalCode(data, (result) => {
        //   setSelectedPostalCode(result.data);
        // });
      } else {
        let data = { cityId: selectedCity.id };
        // requester.getAllPostalCodesByCityId(data, (result) => {
        //   setPostalCodes(result.data);
        //   setSelectedPostalCode();
        // });
      }
    }
  }, [selectedCity]);

  useEffect(() => {
    setSelectedShippingInfo([]);
  }, [type]);

  /* 국내 주소 관련  */
  const [enroll_company, setEnroll_company] = useState({});

  /* 국내 주소 관련 끝 */
  const addressKrModalClick = () => {
    NiceModal.show("addressKr", { onCallback: addressKrCallback });
    setSelectedShippingInfo((prev) => ({
      ...prev,
      address_1: "",
      address_2: "",
      postal_code: "",
    }));
  };
  const addressKrCallback = (dataFromModal) => {
    
    // 여기에서 모달에서 받은 데이터를 처리합니다.

    setSelectedShippingInfo((prevState) => ({
      ...prevState,
      address_1: dataFromModal.address,
      postal_code: dataFromModal.zonecode, // zonecode도 받고 싶다면 이런 식으로 추가할 수 있습니다.
    }));
  };

  const onAddShippingInfoClick = () => {
    NiceModal.show("shippingInfoAddKrModal", {
      callback: onShippingInfoModalClose,
      setAdd: setAdd,
    });
  };
  const onShippingInfoModalClose = (value) => {
    setDefaultShippingInfo(value[0]);
  };

  // 기존 배송지 리스트중에 하나 선택했을 때,
  const onShippingInfoChange = (shippingAddressId) => {
    if (shippingAddress && shippingAddress.length > 0) {
      const selectedAddress = shippingAddress.find(
        (address) => address.id === shippingAddressId
      );

      if (selectedAddress) {
        setSelectedShippingInfo(selectedAddress);
      }
    }
    setSelectAddressId(shippingAddressId);
  };

  const handleAddShippingAddress = async () => {
    if (type === "NEW") {
      const requiredFields = [0, 1, 2, 3, 4, 5];
      const isEmpty = requiredFields.some((index) => {
        const value =
          inputs.current &&
          inputs.current[index]
            ?.getValue()
            .toString()
            .trim();
        return !value;
      });

      if (isEmpty) {
        toast.error(t("배송지 정보를 모두 입력해주세요"), {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        return;
      }

      let data = {
        address: {
          name: inputs.current && inputs.current[0]?.getValue().toString(),
          first_name:
            inputs.current && inputs.current[1]?.getValue().toString(),
          last_name: "",
          province: "",
          postal_code:
            inputs.current && inputs.current[2]?.getValue().toString(),
          address_1: inputs.current && inputs.current[3]?.getValue().toString(),
          address_2: inputs.current && inputs.current[4]?.getValue().toString(),
          city: "city",
          country_code: "kr",
          phone: inputs.current && inputs.current[5]?.getValue().toString(),
          company: "default",
        },
      };
      
      await storeRequester.addShippingAddress(data);
      setAdd((prev) => !prev);
    }
  };

  const addressBtnStyle = {
    backgroundColor: "#4d4f56",
    color: "white",
    padding: "5px 15px",
  };


  useEffect(() => {
    if (inputs.current && inputs.current.length === 6 && type === "NEW") {
      setSelectAddress({
        name: inputs.current[0]?.getValue() || "",
        first_name: inputs.current[1]?.getValue() || "",
        last_name: "",
        province: "",
        postal_code: inputs.current[2]?.getValue() || "",
        address_1: inputs.current[3]?.getValue() || "",
        address_2: inputs.current[4]?.getValue() || "",
        phone: inputs.current[5]?.getValue() || "",
        company: "default_company",
        city: "city",
        country_code: "kr",
      });
    }
  }, [
    inputs.current[0]?.getValue(),
    inputs.current[1]?.getValue(),
    inputs.current[2]?.getValue(),
    inputs.current[3]?.getValue(),
    inputs.current[4]?.getValue(),
    inputs.current[5]?.getValue(),
    inputs.current[6]?.getValue(),
  ]);

  return (
    <FlexChild>
      {isMobile ? (
        <VerticalFlex gap={10}>
          <FlexChild padding={"0 0 10px 0"}>
            <Center width={"100%"} textAlign={"left"}>
              <P size={24} weight={"bold"}>
                {t("shippingInfoAdd")}
              </P>
            </Center>
          </FlexChild>
          <FlexChild>
            <div className={style.mobileAddressWrap}>
              <VerticalFlex gap={10}>
                <FlexChild>
                  <HorizontalFlex gap={25}>
                    <FlexChild>
                      <HorizontalFlex gap={20}>
                        <FlexChild width={"max-content"}>
                          <P weight={"bold"}>
                            {defaultShippingInfo &&
                              defaultShippingInfo.shippingName}
                          </P>
                        </FlexChild>
                        <FlexChild>
                          {/* <P size={10} borderRadius={"10px"} padding={"1px 9px"} backgroundColor={"#4d4f56"} color={"white"}>기본 배송지</P> */}
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild justifyContent={"flex-end"}>
                      <P
                        cursor
                        onClick={shippingInfoClick}
                        padding={"1px 6px"}
                        borderRadius={"3px"}
                        border={"1.5px solid #999"}
                        color={"#999"}
                        backgroundColor={"white"}
                        size={"10pt"}
                      >
                        {t("shippingAddressList")}
                      </P>
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  <div style={{ height: "1px", backgroundColor: "#ddd" }} />
                </FlexChild>
                <FlexChild>
                  {selectedShippingInfo && selectedShippingInfo.address_1 ? (
                    <VerticalFlex flexStart>
                      <FlexChild>
                        <P>
                          {selectedShippingInfo && selectedShippingInfo.name}
                        </P>
                      </FlexChild>
                      <FlexChild>
                        <P>
                          {selectedShippingInfo &&
                            selectedShippingInfo.postal_code}
                        </P>
                      </FlexChild>
                      <FlexChild>
                        <P>
                          {selectedShippingInfo &&
                            selectedShippingInfo.address_1 +
                              " " +
                              selectedShippingInfo.address_2}
                        </P>
                      </FlexChild>
                      <FlexChild>
                        <P>
                          {selectedShippingInfo && selectedShippingInfo.phone}
                        </P>
                      </FlexChild>
                    </VerticalFlex>
                  ) : (
                    <VerticalFlex flexStart>
                      <FlexChild>
                        <P>배송지를 추가해주세요</P>
                      </FlexChild>
                      <FlexChild>
                        <P
                          cursor
                          onClick={onAddShippingInfoClick}
                          size={12}
                          weight={"bold"}
                          color={"var(--main-color)"}
                        >
                          + 배송지 추가
                        </P>
                      </FlexChild>
                    </VerticalFlex>
                  )}
                </FlexChild>
              </VerticalFlex>
            </div>
          </FlexChild>
        </VerticalFlex>
      ) : (
        <VerticalFlex gap={10}>
          <FlexChild padding={"0 0 10px 0"}>
            <Center width={"100%"} textAlign={"left"}>
              <P size={20} weight={"bold"}>
                {t("shippingInfoAdd")}
              </P>
            </Center>
          </FlexChild>
          <FlexChild>
            <div className={style.addressHeaderWrap}>
              <HorizontalFlex gap={20}>
                <FlexChild width={"20%"}>
                  <P weight={"bold"} size={14}>
                    {t("배송지")}
                  </P>
                </FlexChild>
                <FlexChild width={"initial"}>
                  <Radio
                    name="shipping"
                    value="EXISTING"
                    selectedValue={type}
                    onCheckedChange={handleCheckedChange}
                  />
                  <P>{t("originalShippingAddress")}</P>
                </FlexChild>
                <FlexChild width={"initial"}>
                  <Radio
                    name="shipping"
                    value="NEW"
                    selectedValue={type}
                    onCheckedChange={handleCheckedChange}
                  />
                  <P>{t("addNewAddress")}</P>
                </FlexChild>
                <FlexChild />
              </HorizontalFlex>
            </div>
          </FlexChild>
          <FlexChild>
            <div style={{ height: "1px", backgroundColor: "#dcdcdc" }} />
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("배송지명")}
                </P>
              </FlexChild>
              <FlexChild width={"max-content"}>
                <div style={{ width: "initial" }}>
                  {type === "NEW" ? (
                    <InputText
                      ref={(el) => (inputs.current[0] = el)}
                      regExp={[textFormat]}
                      disabled={disabled}
                      placeHolder={t("배송지명")}
                      value={
                        selectedShippingInfo
                          ? selectedShippingInfo.province
                          : null
                      }
                    />
                  ) : (
                    <CFormSelect
                      onChange={(e) => onShippingInfoChange(e.target.value)}
                    >
                      <option>선택하세요</option>
                      {shippingAddress &&
                        shippingAddress.map((data, index) => {
                          return (
                            <option value={data.id}>{data.province}</option>
                          );
                        })}
                    </CFormSelect>
                  )}
                </div>
              </FlexChild>
              <FlexChild>
                <HorizontalFlex justifyContent={"flex-start"} gap={10}>
                  <FlexChild>
                    <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                      {type === "NEW" && (
                        <FlexChild width={"50%"}>
                          <button
                            onClick={handleAddShippingAddress}
                            style={{
                              backgroundColor: "#296AFF",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "3px",
                              color: "white",
                            }}
                          >
                            <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                              신규 주소 추가
                            </p>
                          </button>
                        </FlexChild>
                      )}
                    </HorizontalFlex>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("name")}
                </P>
              </FlexChild>

              <FlexChild width={"39%"}>
                <VerticalFlex>
                  <InputText
                    ref={(el) => (inputs.current[1] = el)}
                    regExp={[textFormat]}
                    disabled={disabled}
                    placeHolder={t("name")}
                    value={
                      selectedShippingInfo
                        ? selectedShippingInfo.first_name +
                          selectedShippingInfo.last_name
                        : null
                    }
                  />
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("address")}
                </P>
              </FlexChild>
              <FlexChild>
                <VerticalFlex gap={10} flexStart>
                  <FlexChild width={"60%"}>
                    <HorizontalFlex gap={20}>
                      <FlexChild>
                        <InputText
                          readOnly
                          ref={(el) => (inputs.current[2] = el)}
                          disabled={disabled}
                          value={
                            selectedShippingInfo
                              ? selectedShippingInfo.postal_code
                              : enroll_company
                              ? enroll_company.zonecode
                              : ""
                          }
                          regExp={[textFormat]}
                        />
                      </FlexChild>
                      <FlexChild>
                        {disabled ? null : (
                          <CustomButton
                            style={addressBtnStyle}
                            onClick={addressKrModalClick}
                            text={"우편번호 찾기"}
                          />
                        )}
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                  <FlexChild>
                    <HorizontalFlex gap={10}>
                      <FlexChild>
                        <InputText
                          readOnly
                          ref={(el) => (inputs.current[3] = el)}
                          disabled={disabled}
                          value={
                            selectedShippingInfo
                              ? selectedShippingInfo.address_1
                              : enroll_company
                              ? enroll_company.address
                              : ""
                          }
                          regExp={[textFormat]}
                        />
                      </FlexChild>
                      <FlexChild>
                        <InputText
                          ref={(el) => (inputs.current[4] = el)}
                          disabled={disabled}
                          value={
                            selectedShippingInfo
                              ? selectedShippingInfo.address_2
                              : ""
                          }
                          regExp={[textFormat]}
                          placeHolder={t("상세주소를 입력해주세요 .")}
                        />
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex justifyContent={"flex-start"} gap={10}>
              <FlexChild width={"20%"}>
                <P weight={"bold"} size={14}>
                  {t("number")}
                </P>
              </FlexChild>
              <FlexChild>
                <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                  <FlexChild width={"49%"}>
                    <InputText
                      ref={(el) => (inputs.current[5] = el)}
                      disabled={disabled}
                      placeHolder={t("enterPhoneNumber")}
                      value={
                        selectedShippingInfo
                          ? selectedShippingInfo?.phone?.replace(/\D/g, "")
                          : null
                      }
                      regExp={[mobileNoFormat]}
                    />
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
        </VerticalFlex>
      )}
    </FlexChild>
  );
}

export default ShippingInfomation;
